<template>
  <header class="title-bar">
  <h1>Welcome to {{ name }}</h1>
    <nav>
      <ul  class="menu-bar">
        <li><router-link to="/">Home</router-link></li>
        <li><router-link to="/research">Research</router-link></li>
        <li><router-link to="/staffs">Staffs</router-link></li>
        <li><router-link to="/topics">Topics</router-link></li>
        <li><router-link to="/">About</router-link></li>
      </ul>
    </nav>
  </header>
</template>


<script>
export default {
  data() {
    return {
      name: "Fusion Intelligence Research Institute",
    };
  },
};
</script>

<!--template>
  <header>
  <h1>Welcome to {{ name }}</h1>
    <nav>
      <ul class="menu-bar">
        <li><router-link to="/about">About Us</router-link></li>
        <li><router-link to="/research">Our Research</router-link></li>
        <li><router-link to="/staffs">Staffs</router-link></li>
        <li><router-link to="/topics">Interesting Topics</router-link></li>
      </ul>
    </nav>
  </header>
</template-->


<style>
/*header {
   Add styles for the title bar 
  background: #35495e;
  color: white;
  padding: 1rem;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 1000;
}*/
.menu-bar {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.menu-bar li {
  display: inline;
}

.menu-bar a {
  color: white;
  text-decoration: none;
  font-weight: bold;
}
</style>